import React from "react"
import { Typography, Box, BoxProps } from "@material-ui/core"

export type LegendKey = {
  color: string
  label: string
  shape?: "round" | "square"
}

interface LegendProps extends BoxProps {
  keys: LegendKey[]
}

export const Key: React.FC<LegendKey> = ({ color, label, shape = "round" }) => {
  return (
    <Box display="flex" alignItems="center" mr={2}>
      <Box
        width={10}
        height={10}
        borderRadius={shape === "round" ? 5 : 0}
        bgcolor={color}
        mr={1}
      />
      <Box
        position="relative"
        top={2}
        component={Typography}
        // @ts-ignore
        variant="body2"
      >
        {label}
      </Box>
    </Box>
  )
}

export const Legend: React.FC<LegendProps> = ({ keys, ...props }) => {
  return (
    <Box {...props}>
      <Box display="flex">
        {keys.map(key => (
          <Key key={key.label} {...key} />
        ))}
      </Box>
    </Box>
  )
}
